'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Common.SimpleHepToggle', ['AVRO.Common.Configuration', 'AVRO.Common.BootstrapFeatures']).run(require('./config/SimpleHepToggleConfig')).service('SimpleHepToggleService', require('./services/SimpleHepToggleService'));